import {
  TDirectChatState,
  TActions,
  TChatContact,
  TPresence,
  TDirectMessage,
} from '../../types/direct-chat';

export const directChatActionTypes = {
  SET_CONTACTS: 'DIRECT_CHAT/SET_CONTACTS',
  SET_PRESENCE: 'DIRECT_CHAT/SET_PRESENCE',
  SET_RECEIVER: 'DIRECT_CHAT/SET_RECEIVER',
  GET_MESSAGES_REQUEST: 'DIRECT_CHAT/GET_MESSAGES_REQUEST',
  GET_MESSAGES_SUCCESS: 'DIRECT_CHAT/GET_MESSAGES_SUCCESS',
  RESET_MESSAGES: 'DIRECT_CHAT/RESET_MESSAGES',
  ADD_DIRECT_MESSAGE: 'DIRECT_CHAT/ADD_DIRECT_MESSAGE',
  GET_LAST_MESSAGES_REQUEST: 'DIRECT_CHAT/GET_LAST_MESSAGES_REQUEST',
  GET_LAST_MESSAGES_SUCCESS: 'DIRECT_CHAT/GET_LAST_MESSAGES_SUCCESS',
  GET_UNREADS_REQUEST: 'DIRECT_CHAT/GET_UNREADS_REQUEST',
  GET_UNREADS_SUCCESS: 'DIRECT_CHAT/GET_UNREADS_SUCCESS',
  REMOVE_UNREADS: 'DIRECT_CHAT/REMOVE_UNREADS',
  SET_LOADING: 'DIRECT_CHAT/SET_LOADING',
  SET_LOADING_LAST_MESSAGES: 'DIRECT_CHAT/SET_LOADING_LAST_MESSAGES',
} as const;

const initialState: TDirectChatState = {
  contacts: [],
  receiver: '',
  messages: [],
  lastMessages: [],
  unreads: {},
  isLoading: true,
  isLoadingLastMessages: true,
};

export default (state = initialState, action: TActions): TDirectChatState => {
  switch (action.type) {
    case directChatActionTypes.SET_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
      };

    case directChatActionTypes.GET_LAST_MESSAGES_SUCCESS:
      return {
        ...state,
        lastMessages: action.payload,
      };

    case directChatActionTypes.GET_UNREADS_SUCCESS:
      return {
        ...state,
        unreads: action.payload,
      };

    case directChatActionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case directChatActionTypes.SET_LOADING_LAST_MESSAGES:
      return {
        ...state,
        isLoadingLastMessages: action.payload,
      };

    case directChatActionTypes.SET_PRESENCE:
      return {
        ...state,
        contacts: state.contacts.map((contact: TChatContact) => {
          if (contact.jid === action.payload.jid) {
            contact.status = action.payload.status;
          }

          return contact;
        }),
      };

    case directChatActionTypes.SET_RECEIVER:
      return {
        ...state,
        receiver: action.payload,
      };

    case directChatActionTypes.GET_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: action.payload as any,
      };

    case directChatActionTypes.RESET_MESSAGES:
      return {
        ...state,
        receiver: '',
        messages: [],
      };

    default:
      return state;
  }
};

export const actions = {
  setContacts: (payload: TChatContact[]) => ({ type: directChatActionTypes.SET_CONTACTS, payload }),
  setPresence: (payload: TPresence) => ({ type: directChatActionTypes.SET_PRESENCE, payload }),
  setReceiver: (payload: string) => ({ type: directChatActionTypes.SET_RECEIVER, payload }),
  getMessagesRequest: (payload: string) => ({
    type: directChatActionTypes.GET_MESSAGES_REQUEST,
    payload,
  }),
  getUnreadsRequest: () => ({ type: directChatActionTypes.GET_UNREADS_REQUEST }),
  resetMessages: () => ({ type: directChatActionTypes.RESET_MESSAGES }),
  addDirectMessage: (payload: TDirectMessage) => ({
    payload,
    type: directChatActionTypes.ADD_DIRECT_MESSAGE,
  }),
  getLastMessagesRequest: () => ({ type: directChatActionTypes.GET_LAST_MESSAGES_REQUEST }),
};
